module.exports = __webpack_public_path__ + "img/banner3.ef5695ed.png";